import React, { useEffect, useState } from 'react';
import { userService } from 'services/user.service';
import { Paginator } from 'primereact/paginator';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { routes } from 'utils/routes';
import { useNavigate } from 'react-router-dom';
import DeleteItem from 'views/components/delete-modal';
import { dealService } from 'services/deal.service';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { formatDate, getSortIcon, handleFilters } from 'utils/common-functions';
import { Skeleton } from 'primereact/skeleton';
import { _Object, getStatusLabel } from 'utils/interfaces';
import { useFormik } from 'formik';

const DealLisiting = () => {
  const [employeeList, setEmployeeList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState<_Object>({})
  const [visible, setVisible] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const navigate = useNavigate();
  const [filterData, setFilterData] = useState<_Object>({
    page: 1,
    jobType: '', status: '',
    per_page: 10,
    q: "",
    sort: '-created_at',
  })
  const fetchEmployeeList = async () => {
    try {
      setLoading(true);
      const data: any = await dealService.getDeals(filterData);

      data.items && setEmployeeList(data.items);
      setPagination(data.pagination);
    } catch (error) {
      console.error('Error fetching deals:', error);
    } finally {
      setLoading(false);
    }
  };

  const deleteItem = async (itemToDelete: any) => {
    if (!itemToDelete) return;
    try {
      setLoading(true);
      const response = await userService.deleteUsers(itemToDelete);
      if (!response.error) {
        await fetchEmployeeList();
        setVisible(false);
        setItemToDelete(null);
      }
    } catch (error) {
      console.error('Error deleting deal:', error);
    } finally {
      setLoading(false);
    }
  };

  const onPageChange = (event: any) => {
    const currentPage = Math.floor(event.first / event.rows) + 1;

    setFilterData((prev) => ({
      ...prev,
      page: currentPage,
      per_page: event.rows,
    }));
  };

  useEffect(() => {
    fetchEmployeeList();
  }, [filterData]);

  const formikFilter = useFormik({
    initialValues: filterData,
    enableReinitialize: true,
    onSubmit: (values: _Object) => {
      setFilterData((prev) => ({
        ...prev,
        q: values.q.trim(),
        page: 1
      }));
    }
  });
console.log('pagination',pagination);

  return (
    <div className="DealLisiting">
      <div className="flex justify-content-between align-items-center">
        <div className="p-inputgroup search-bar col-6">
          <form onSubmit={formikFilter.handleSubmit}>
            <div className='form-group mb-0 mr-2'>
              <Button type='submit' className='search-loading bg-transparent p-0 border-none'
                disabled={loading}>
                {loading && <i className="pi pi-spin pi-spinner"
                  style={{ fontSize: '1rem' }}
                >
                </i>}
              </Button>

              <IconField iconPosition="left">
                <InputIcon className="pi pi-search"> </InputIcon>
                <InputText placeholder="Search"
                  name='q'
                  onChange={formikFilter.handleChange}
                  onBlur={formikFilter.handleBlur}
                  value={formikFilter.values.q} />
              </IconField>

              {filterData.q && <Button type='button'
                onClick={() => {
                  setFilterData((prev) => ({
                    ...prev,
                    q: '',
                    page: 1
                  }))
                }}
                severity="secondary" text className='bg-transparent p-0 border-none absolute top-0 right-0 mr-3'>
                <span className="pi pi-times "> </span>
              </Button>}
            </div>
          </form>
        
          {pagination?.total_items > 0 &&
            <div className='total-items flex align-items-center text-sm'>
              Total items: {pagination.total_items || ""}
            </div>
          }
        </div>
        
        <div className="col- text-right">
          <Button label="Add New Deal" icon="pi pi-plus" className="primary" onClick={() => navigate(`${routes.deals}/create`)} />
        </div>
      </div>

      <div className="col">
        <div className="card">
          <table className='w-full'>
            <thead>
              <tr>
                <th>#</th>
                <th>Deal Title</th>
                <th>Amount</th>
                <th>Type</th>
                <th>
                  <button
                    className="btn p-0 border-0"
                    onClick={() => { handleFilters('sort', filterData.sort === '-created_at' ? 'created_at' : '-created_at', setFilterData) }}>
                    Start Date
                    <i className={`pi ${getSortIcon(filterData.sort.includes('created_at') ? filterData.sort : '')}`}></i>
                  </button>
                </th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading && Array.from({ length: 5 }).map((_, index) => (
                <tr key={index}>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                </tr>
              ))}
              {!loading && employeeList?.map((item: _Object, i: number) => (
                <tr>
                  <td>{((filterData.page - 1) * filterData.per_page) + (i + 1)}</td>
                  <td> {item?.title || "-"}</td>
                  <td>{item?.amount || '-'}</td>
                  <td>{item?.type || '-'}</td>
                  <td>{formatDate(item?.created_at) || '-'}</td>
                  <td>{getStatusLabel(item?.status) || '-'}</td>
                  <td>
                    <div>
                      <Button
                        icon="pi pi-pencil"
                        rounded
                        text
                        className="h-auto w-auto bg-transparent p-0 border-noround inline"
                        onClick={() => navigate(`${routes.deals}/edit/${item.id}`)}
                        style={{ color: '#959CB6' }}
                      />
                      <Button
                        icon="pi pi-trash"
                        onClick={() => {
                          setVisible(true);
                          setItemToDelete(item.id);
                        }}
                        rounded
                        text
                        className="h-auto w-auto bg-transparent p-0 border-noround inline"
                        style={{ color: 'var(--torch-red)' }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
              {!loading && employeeList?.length === 0 && <tr>
                <td colSpan={11}>No available options</td>
              </tr>
              }
            </tbody>
          </table>

        </div>

        {!loading && pagination?.total_pages > 1 &&
          <Paginator
            first={(filterData.page - 1) * filterData.per_page}
            rows={filterData.per_page}
            totalRecords={pagination.total_items}
            rowsPerPageOptions={[10, 20, 30]}
            onPageChange={onPageChange}
          />
        }
        <DeleteItem
          title="Deal"
          visible={visible}
          onHide={() => setVisible(false)}
          deleteItem={() => deleteItem(itemToDelete)}
        />
      </div>
    </div>
  );
};

export default DealLisiting;
